import date from "../../utils/date";

export function SET_STATUS(state, status) {
  state.status.push({ ...status, show: true });
  setTimeout(() => {
    state.status.shift()
  }, 5000)

  if (status.notify) SET_NOTIFY(state, status.notify)
}

export function CLEAR_NOTIFY(state) {
  state.notify = {
    read: [],
    readed: []
  }
}

export function SET_NOTIFY(state, notify) {
  state.notify.read.unshift({
    ...notify,
    msg: notify.titulo || notify,
    time: notify.publicado_em ? date.dateTimeBr(notify.publicado_em) : date.dateTimeBr()
  });
}

export function SET_MODALS(state, modal) {
  state.modals.push(modal)
}

export function SET_COMM_READED(state, id) {
  state.notify.read.map(n => {
    if (n.id_comunicado == id) n.visualizado = true
  })
}

export function SET_NOTIFY_READED(state) {
  if (state.notify.read.length) {
    state.notify.readed = state.notify.readed.concat(state.notify.read);
    state.notify.read = [];
  }
}

export function REMOVE_STATUS(state, index) {
  state.status.splice(index, 1);
}

export function SET_BANK(state, bank) {
  state.bank = bank
}

export function SET_STATS(state, stats) {
  state.stats = stats
}